/* eslint-disable no-const-assign */
/* eslint-disable no-undef */
import React, { useEffect, useState } from "react";
import { UmbracoStep } from "components/Umbraco/UmbracoContext";
import { Parser } from "html-to-react";
import HorizonalChartsWrapper from "./components/HorizonalChartsWrapper";
import "./step10.scss";
import "styles/_uikit-overrides.scss";

import utils from "utils";
import Footer from "components/Footer";
import {
  CheckValidInputs,
  StepBody,
  StepFooter,
  TextField,
  PhoneField,
  IdNumberField,
  useInput,
  MainCond,
  Spinner,
  Line,
  RowCenter,
} from "meitav-uikit";

import { saveModel, setDataLayer } from "../../../../../utils/Functions";

const { UmbracoUtills, rest } = utils;

export default function Step10({
  resource,
  recapchaKey,
  model,
  setModel,
  setStep,
  nextText,
  step,
  resourceError,
}) {
  const p = new Parser();
  const resourceStep = UmbracoStep(resource, `FirstSub1Step`);
  const phone = useInput(
    UmbracoUtills.getValueByKey(resourceStep, "phoneNumber"),
    model.mainUser.phone,
    [MainCond.empty, MainCond.phone, MainCond.onlyDigits]
  );
  const firstName = useInput(
    UmbracoUtills.getValueByKey(resourceStep, "firstName"),
    model.mainUser.firstName,
    [MainCond.empty, MainCond.hebrew, MainCond.minLength]
  );
  const lastName = useInput(
    UmbracoUtills.getValueByKey(resourceStep, "lastName"),
    model.mainUser.lastName,
    [MainCond.empty, MainCond.hebrew, MainCond.minLength]
  );
  //const email = useInput(UmbracoUtills.getValueByKey(resourceStep, 'email'), model.mainUser.email, [MainCond.empty, MainCond.email]);
  const iDNumber = useInput(
    UmbracoUtills.getValueByKey(resourceStep, "idLabel"),
    model.mainUser.iDNumber,
    [MainCond.empty, MainCond.identity]
  );

  //const [popupObj, setPopupObj] = useState("");
  const [showSpinner, setShowSpinner] = useState(false);

  const handleNext = async () => {
    if (!CheckValidInputs([phone, iDNumber, firstName, lastName])) {
      return;
    }
    setDataLayer(
      "PM - private details",
      "/JoinPersonalDetails",
      "פרטים ראשוניים",
      "המשך מוצלח של שלב פרטים ראשונים"
    );
    const formData = {};
    formData.guid = localStorage.getItem("investPolicyGUID");
    const result = await rest.post("/api/Manager/GetLobbyDetails", {
      data: formData,
    });

    setShowSpinner(true);
    let tmpModel = model;
    tmpModel.mainUser.firstName = firstName.value;
    tmpModel.mainUser.lastName = lastName.value;
    tmpModel.mainUser.phone = phone.value;
    tmpModel.mainUser.iDNumber = iDNumber.value;
    tmpModel.currentStepID = 11;
    tmpModel.sectorCode = result.data.sectorCode;
    setModel(tmpModel);

    const a = callbacLogin();
  };

  function callbacLogin() {
    const investPolicyGUID = localStorage.getItem("investPolicyGUID"); //'24A0ECA0-7B1B-4CEB-B993-3FB7C0A55717' //

    const data = {
      phone: phone.value,
      firstName: firstName.value,
      lastName: lastName.value,
      iDNumber: iDNumber.value,
      utm_source: localStorage.getItem("utm_source"),
      utm_medium: localStorage.getItem("utm_medium"),
      investPolicyGUID,
    };
    return new Promise(function (resolve, reject) {
      if (grecaptcha === undefined) {
        alert("Recaptcha non definito");
        reject();
      }
      grecaptcha.enterprise
        .execute(recapchaKey, {
          action: "Login",
        })
        .then(function (token) {
          rest
            .post("/api/Manager/Login", {
              data: data,
              headers: {
                gCaptcha: token,
                action: "Login",
              },
            })
            .then((res) => {
              if (!res?.data?.processId) {
                window.location.href = "/CustomerInvestPolicy";
              } else {
                // window.localStorage.setItem("otpGuid", res?.data?.otpGuid);
                window.localStorage.setItem(
                  "processGuid",
                  res?.data?.processId
                );
                callbaclOtp(res.data.processId);
                let tmpModel = model;
                let sectorCodeFirst = model.sectorCode;
                tmpModel.processId = res.data.processId;
                if (res?.data?.isExistingProcess) {
                  tmpModel = res.data;
                  tmpModel.sectorCodeFirst = sectorCodeFirst;
                }

                setModel(tmpModel);
                saveModel(tmpModel, 11);
                setStep(11);
                return true;
              }
            });
        });
    });
  }

  function callbaclOtp(processId) {
    return new Promise(function (resolve, reject) {
      if (grecaptcha === undefined) {
        alert("Recaptcha non definito");
        reject();
      }
      grecaptcha.enterprise
        .execute(recapchaKey, {
          action: "postData_otp",
        })
        .then(function (token) {
          rest
            .post(`/api/Manager/SendOtp?processId=${processId}`, {
              headers: {
                gCaptcha: token,
                action: "postData_otp",
              },
            })
            .then(function (result) {
              localStorage.setItem("otpGuid", result?.data?.otpGuid);
              setStep(11);
            });
        });
    });
  }

  const handlePrev = async () => {
    setDataLayer(
      "PM - Levels",
      "/JoinPersonalDetails",
      "חזור לשלב הקודם",
      "חזרה - " + step
    );
    window.location.href = "/lobby";
  };

  return (
    <>
      {showSpinner ? (
        <Spinner />
      ) : (
        <div className="step10">
          <StepBody>
            <HorizonalChartsWrapper
              riskLevelLow={UmbracoUtills.getValueByKey(
                resourceStep,
                "riskLevelLow"
              )}
              riskLevelHigh={UmbracoUtills.getValueByKey(
                resourceStep,
                "riskLevelHigh"
              )}
              className={`mb-4 `}
            />
            <RowCenter>
              <Line className="line">
                <TextField {...firstName} id="firstName" />
                <TextField {...lastName} id="lastName" />
              </Line>
              <Line className="line">
                <IdNumberField id="iDNumber" {...iDNumber} />
                <PhoneField {...phone} id="phone" />
              </Line>
            </RowCenter>
          </StepBody>

          <StepFooter
            nextText={nextText}
            handleNext={handleNext}
            handlePrev={handlePrev}
          />
          <Footer
            text={p.parse(
              UmbracoUtills.getValueByKey(resourceStep, "mainText")
            )}
          ></Footer>
        </div>
      )}
    </>
  );
}
